module.exports = __webpack_public_path__ + "static/media/mada_logo.17c3d8da.svg";